export function deepMerge(target, source) {
  if (Array.isArray(target) && Array.isArray(source)) {
    return target.concat(source)
  } else if (typeof target == "object" && typeof source == "object") {
    for (let key in source) {
      if (target[key]) {
        target[key] = deepMerge(target[key], source[key])
      } else {
        target[key] = source[key]
      }
    }
    return target
  } else {
    return source
  }
}
